"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EngagementPill = void 0;
var react_1 = __importDefault(require("react"));
var capitalize_1 = __importDefault(require("lodash/capitalize"));
var dynamic_1 = require("@vanilla-extract/dynamic");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var tokens_1 = require("@qwilr/kaleidoscope/tokens");
var EngagementIcon_1 = require("./EngagementIcon");
var Utils_1 = require("./Utils");
var styles = __importStar(require("./EngagementPill.css"));
var EngagementPill = function (_a) {
    var _b;
    var engagementLevel = _a.engagementLevel, isCalculating = _a.isCalculating;
    return (react_1.default.createElement(kaleidoscope_1.Stack, { className: styles.engagementPill, style: (0, dynamic_1.assignInlineVars)((_b = {},
            _b[styles.engagementPillColor] = getEngagementBackgroundColour(engagementLevel),
            _b)), direction: "horizontal", align: "center", gap: "xs" },
        react_1.default.createElement(EngagementIcon_1.EngagementIcon, { engagementLevel: engagementLevel, isCalculating: isCalculating }),
        react_1.default.createElement(kaleidoscope_1.Label, null, (0, capitalize_1.default)((0, Utils_1.getEngagementLevelDisplayName)(engagementLevel, isCalculating)))));
};
exports.EngagementPill = EngagementPill;
var engagementBackgroundColourMap = {
    "highly engaged": tokens_1.palette.purple100,
    engaged: tokens_1.palette.green100,
    neutral: tokens_1.palette.grey300,
    disengaged: tokens_1.palette.orange100,
    "highly disengaged": tokens_1.palette.red100,
};
function getEngagementBackgroundColour(engagementLevel) {
    var _a;
    if (engagementLevel == undefined)
        return tokens_1.tokens.color.background;
    return (_a = engagementBackgroundColourMap[engagementLevel]) !== null && _a !== void 0 ? _a : tokens_1.tokens.color.background;
}
